import styled, { css } from 'styled-components';
import { colors } from '@chegg-ui/theme';
export var Divider = styled.hr.withConfig({
  componentId: "sc-1lfgb02-0"
})(["border:none;border-top:1px solid ", ";height:1px;margin:10px 0;"], colors.greyLight);
export var PaddingContainer = styled.div.withConfig({
  componentId: "sc-1lfgb02-1"
})(["", ""], function (_ref) {
  var top = _ref.top,
    right = _ref.right,
    bottom = _ref.bottom,
    left = _ref.left,
    backgroundColor = _ref.backgroundColor;
  return css(["padding:", "px ", "px ", "px ", "px;background-color:", ";"], top || 0, right || 0, bottom || 0, left || 0, backgroundColor);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/VpnNotificationBanner/styled.js
// module id = 3981
// module chunks = 11